import AppLauncherCollection from "./AppLauncherCollectionRoot.vue"

export default AppLauncherCollection
